import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgComment = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.8041 13.2733H4.58768C2.96806 13.2733 1.66846 11.9 1.66846 10.2V5.07333C1.66846 3.37333 2.9746 2 4.58768 2H11.2359C12.849 2 14.1551 3.37333 14.1551 5.07333V11.22L14.7298 14.2933L11.8106 13.2667L11.8041 13.2733Z",
		stroke: "#3B3B3D",
		strokeLinejoin: "round"
	})
});
export default SvgComment;
